/* istanbul ignore file */
import { createRouteRef } from "@backstage/core-plugin-api";

export const rootRouteRef = createRouteRef({
  id: "circles",
});

export const circleTypeManagementRouteRef = createRouteRef({
  id: "circle-type-management",
});
